import React from 'react';
import './UIItemQuantityGuide.css';

const UIItemQuantityGuide = ({ ...children }) => (
  <span
    className="UI-ItemQuantityGuide__duzz-commercial"
    style={{ fontSize: children.size }}
  >
    {children.value}
  </span>
);

export default UIItemQuantityGuide;
